import "./categoryposts.css";
import { useEffect, useState } from "react";
import { PostItem } from "../../components/posts/PostItem";
import { Post } from "../forum/Forum";
import Loader from "../../components/loader/Loader";
import { useParams } from "react-router-dom";
import axios from "axios";

export const Categoryposts = () => {
  const [visiblePosts, setVisiblePosts] = useState(3);
  const [posts, setPosts] = useState<Post[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { category } = useParams();

  const loadMorePosts = () => {
    setVisiblePosts((prevVisiblePosts) => prevVisiblePosts + 3);
  };

  useEffect(() => {
    const fetchPosts = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get<Post[]>(
          `${process.env.REACT_APP_BASE_URL}/posts/categories/${category}`
        );
        setPosts(response?.data || []);
      } catch (error) {
        console.error(error);
        setPosts([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPosts();
  }, [category]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <section className="posts">
      {posts.length > 0 ? (
        <div className="container posts__container">
          {posts.slice(0, visiblePosts).map((post) => {
            const { _id: id, thumbnail, category, title, description, creator, createdAt, replies = [], views = 0 } = post;
            const repliesCount = replies.length;
            const lastReply = replies[repliesCount - 1];

            return (
              <PostItem
                key={id}
                postID={id}
                thumbnail={thumbnail || ""}
                category={category || "Uncategorized"}
                title={title || "Untitled"}
                description={description || "No description available"}
                playerID={creator ? creator.toString() : "Unknown"}
                createdAt={new Date(createdAt).toLocaleString()}
                creator={{
                  _id: creator?._id.toString() || "Unknown",
                  name: creator?.name || "Unknown",
                }}     
                repliesCount={repliesCount || 0}
                viewsCount={views || 0}
                lastReplier={lastReply?.user.username || "No replies"}
                lastReplierAvatar={lastReply?.user.avatar || ""}
                lastReplyTime={lastReply ? new Date(lastReply.createdAt).toLocaleTimeString() : ""}
              />
            );
          })}
        </div>
      ) : (
        <h2 className="center">No Posts Found</h2>
      )}
      {visiblePosts < posts.length && (
        <button onClick={loadMorePosts} id="load" className="btn category">
          Load More
        </button>
      )}
    </section>
  );
};
